module.exports = __webpack_public_path__ + "static/media/mountain-image.470b285c.png";